module.exports = __webpack_public_path__ + "img/pizza-5.10dc4231.jpg";